document.addEventListener('DOMContentLoaded', function () {
   const newsletter = document.querySelector('.footer-block--newsletter');
    const blocks = document.querySelectorAll('.footer-block');

    let brandBlock = null;

    blocks.forEach(function (block) {
      if (block.querySelector('.footer-block__brand-info')) {
        brandBlock = block;
      }
    });

    if (newsletter && brandBlock && brandBlock.parentNode) {
      brandBlock.parentNode.insertBefore(newsletter, brandBlock.nextSibling);
    }
  if (window.innerWidth <= 767) {
    const menuBlocks = document.querySelectorAll(".footer-block--menu");

    menuBlocks.forEach((block) => {
      const heading = block.querySelector(".footer-block__heading");
      const content = block.querySelector(".footer-block__details-content");

      // Collapse all by default
      content.style.maxHeight = null;

      heading.addEventListener("click", () => {
        const isOpen = heading.classList.contains("is-expanded");

        // Close all others
        menuBlocks.forEach((otherBlock) => {
          const otherHeading = otherBlock.querySelector(".footer-block__heading");
          const otherContent = otherBlock.querySelector(".footer-block__details-content");
          otherContent.style.maxHeight = null;
          otherHeading.classList.remove("is-expanded");
        });

        // Toggle current
        if (!isOpen) {
          content.style.maxHeight = content.scrollHeight + "px";
          heading.classList.add("is-expanded");
        } else {
          content.style.maxHeight = null;
          heading.classList.remove("is-expanded");
        }
      });
    });
  }
});


